export default [
    {
        "error_id": "T-CD-01",
        "data": [
            {
                "cross_section": 55695,
                "type": "Bridge",
                "deck_dist_data": {
                    "base_title": "Existing",
                    "compare_title": "Multiple Run",
                    "base": {
                        "distance": 80,
                        "width": 28,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                0,
                                753.86,
                                0
                            ],
                            [
                                336,
                                753.85,
                                0
                            ],
                            [
                                342.92,
                                753.83,
                                0
                            ],
                            [
                                353.93,
                                753.8,
                                0
                            ],
                            [
                                365.32,
                                753.77,
                                0
                            ],
                            [
                                388.47,
                                753.71,
                                0
                            ],
                            [
                                398.63,
                                753.68,
                                0
                            ],
                            [
                                410.02,
                                753.65,
                                0
                            ],
                            [
                                421.43,
                                753.62,
                                0
                            ],
                            [
                                432.38,
                                753.6,
                                0
                            ],
                            [
                                444.86,
                                753.56,
                                0
                            ],
                            [
                                457.49,
                                753.53,
                                0
                            ],
                            [
                                469.98,
                                753.5,
                                0
                            ],
                            [
                                485.46,
                                753.34,
                                0
                            ],
                            [
                                496.33,
                                753.22,
                                0
                            ],
                            [
                                511.66,
                                753.06,
                                0
                            ],
                            [
                                525.8,
                                752.92,
                                0
                            ],
                            [
                                542.05,
                                752.75,
                                0
                            ],
                            [
                                546.38,
                                752.7,
                                0
                            ],
                            [
                                560.65,
                                752.56,
                                0
                            ],
                            [
                                576.75,
                                752.39,
                                0
                            ],
                            [
                                580.28,
                                752.35,
                                0
                            ],
                            [
                                594.72,
                                752.2,
                                0
                            ],
                            [
                                611.65,
                                752.03,
                                0
                            ],
                            [
                                625.98,
                                751.88,
                                0
                            ],
                            [
                                638.02,
                                751.88,
                                0
                            ],
                            [
                                655.2,
                                751.88,
                                0
                            ],
                            [
                                695,
                                751.88,
                                748.38
                            ],
                            [
                                775,
                                751.88,
                                748.38
                            ],
                            [
                                783.37,
                                751.85,
                                0
                            ],
                            [
                                792.67,
                                751.84,
                                0
                            ],
                            [
                                804.38,
                                751.82,
                                0
                            ],
                            [
                                821.35,
                                751.79,
                                0
                            ],
                            [
                                832.99,
                                751.77,
                                0
                            ],
                            [
                                848.54,
                                751.74,
                                0
                            ],
                            [
                                856.75,
                                751.73,
                                0
                            ],
                            [
                                872.22,
                                751.7,
                                0
                            ],
                            [
                                887.63,
                                751.68,
                                0
                            ],
                            [
                                898.58,
                                751.68,
                                0
                            ],
                            [
                                913.63,
                                751.68,
                                0
                            ],
                            [
                                931.93,
                                751.68,
                                0
                            ],
                            [
                                946.71,
                                751.68,
                                0
                            ],
                            [
                                951.79,
                                751.68,
                                0
                            ],
                            [
                                962.28,
                                751.68,
                                0
                            ],
                            [
                                975.08,
                                751.68,
                                0
                            ],
                            [
                                985.43,
                                751.68,
                                0
                            ],
                            [
                                993.21,
                                751.7,
                                0
                            ],
                            [
                                1005.79,
                                751.74,
                                0
                            ],
                            [
                                1016.67,
                                751.77,
                                0
                            ],
                            [
                                1036.06,
                                751.82,
                                0
                            ],
                            [
                                1046.95,
                                751.85,
                                0
                            ],
                            [
                                1058.37,
                                751.88,
                                0
                            ],
                            [
                                1080.4,
                                751.94,
                                0
                            ],
                            [
                                1091.84,
                                751.97,
                                0
                            ],
                            [
                                1114.36,
                                752.03,
                                0
                            ],
                            [
                                1134.36,
                                752.09,
                                0
                            ],
                            [
                                1146.79,
                                752.11,
                                0
                            ],
                            [
                                1160.18,
                                752.13,
                                0
                            ],
                            [
                                1173.88,
                                752.15,
                                0
                            ],
                            [
                                1190.71,
                                752.17,
                                0
                            ],
                            [
                                1210.27,
                                752.2,
                                0
                            ],
                            [
                                1232.26,
                                752.23,
                                0
                            ],
                            [
                                1250.64,
                                752.26,
                                0
                            ],
                            [
                                1273.67,
                                752.29,
                                0
                            ],
                            [
                                1276.31,
                                752.3,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                0,
                                753.83,
                                0
                            ],
                            [
                                5.93,
                                753.8,
                                0
                            ],
                            [
                                17.32,
                                753.77,
                                0
                            ],
                            [
                                40.47,
                                753.71,
                                0
                            ],
                            [
                                50.63,
                                753.68,
                                0
                            ],
                            [
                                62.02,
                                753.65,
                                0
                            ],
                            [
                                73.43,
                                753.62,
                                0
                            ],
                            [
                                84.38,
                                753.6,
                                0
                            ],
                            [
                                96.86,
                                753.56,
                                0
                            ],
                            [
                                109.49,
                                753.53,
                                0
                            ],
                            [
                                121.98,
                                753.5,
                                0
                            ],
                            [
                                137.46,
                                753.34,
                                0
                            ],
                            [
                                148.33,
                                753.22,
                                0
                            ],
                            [
                                163.66,
                                753.06,
                                0
                            ],
                            [
                                177.8,
                                752.92,
                                0
                            ],
                            [
                                194.05,
                                752.75,
                                0
                            ],
                            [
                                198.38,
                                752.7,
                                0
                            ],
                            [
                                212.65,
                                752.56,
                                0
                            ],
                            [
                                228.75,
                                752.39,
                                0
                            ],
                            [
                                232.28,
                                752.35,
                                0
                            ],
                            [
                                246.72,
                                752.2,
                                0
                            ],
                            [
                                263.65,
                                752.03,
                                0
                            ],
                            [
                                277.98,
                                751.88,
                                0
                            ],
                            [
                                290.02,
                                751.88,
                                0
                            ],
                            [
                                307.2,
                                751.88,
                                0
                            ],
                            [
                                340,
                                751.88,
                                0
                            ],
                            [
                                420,
                                751.88,
                                0
                            ],
                            [
                                421.11,
                                751.88,
                                0
                            ],
                            [
                                608,
                                751.88,
                                748.38
                            ],
                            [
                                688.06,
                                751.88,
                                748.38
                            ],
                            [
                                698.95,
                                751.85,
                                0
                            ],
                            [
                                710.37,
                                751.88,
                                0
                            ],
                            [
                                732.4,
                                751.94,
                                0
                            ],
                            [
                                743.84,
                                751.97,
                                0
                            ],
                            [
                                766.36,
                                752.03,
                                0
                            ],
                            [
                                786.36,
                                752.09,
                                0
                            ],
                            [
                                798.79,
                                752.11,
                                0
                            ],
                            [
                                812.18,
                                752.13,
                                0
                            ],
                            [
                                825.88,
                                752.15,
                                0
                            ],
                            [
                                842.71,
                                752.17,
                                0
                            ],
                            [
                                862.27,
                                752.2,
                                0
                            ],
                            [
                                884.26,
                                752.23,
                                0
                            ],
                            [
                                902.64,
                                752.26,
                                0
                            ],
                            [
                                925.67,
                                752.29,
                                0
                            ],
                            [
                                928.31,
                                752.3,
                                0
                            ],
                            [
                                1300,
                                752.3,
                                0
                            ]
                        ]
                    },
                    "cmp": {
                        "distance": 80,
                        "width": 28,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                0,
                                753.86,
                                0
                            ],
                            [
                                336,
                                753.85,
                                0
                            ],
                            [
                                342.92,
                                753.83,
                                0
                            ],
                            [
                                353.93,
                                753.8,
                                0
                            ],
                            [
                                365.32,
                                753.77,
                                0
                            ],
                            [
                                388.47,
                                753.71,
                                0
                            ],
                            [
                                398.63,
                                753.68,
                                0
                            ],
                            [
                                410.02,
                                753.65,
                                0
                            ],
                            [
                                421.43,
                                753.62,
                                0
                            ],
                            [
                                432.38,
                                753.6,
                                0
                            ],
                            [
                                444.86,
                                753.56,
                                0
                            ],
                            [
                                457.49,
                                753.53,
                                0
                            ],
                            [
                                469.98,
                                753.5,
                                0
                            ],
                            [
                                485.46,
                                753.34,
                                0
                            ],
                            [
                                496.33,
                                753.22,
                                0
                            ],
                            [
                                511.66,
                                753.06,
                                0
                            ],
                            [
                                525.8,
                                752.92,
                                0
                            ],
                            [
                                542.05,
                                752.75,
                                0
                            ],
                            [
                                546.38,
                                752.7,
                                0
                            ],
                            [
                                560.65,
                                752.56,
                                0
                            ],
                            [
                                576.75,
                                752.39,
                                0
                            ],
                            [
                                580.28,
                                752.35,
                                0
                            ],
                            [
                                594.72,
                                752.2,
                                0
                            ],
                            [
                                611.65,
                                752.03,
                                0
                            ],
                            [
                                625.98,
                                751.88,
                                0
                            ],
                            [
                                638.02,
                                751.88,
                                0
                            ],
                            [
                                655.2,
                                751.88,
                                0
                            ],
                            [
                                695,
                                751.88,
                                748.38
                            ],
                            [
                                775,
                                751.88,
                                748.38
                            ],
                            [
                                783.37,
                                751.85,
                                0
                            ],
                            [
                                792.67,
                                751.84,
                                0
                            ],
                            [
                                804.38,
                                751.82,
                                0
                            ],
                            [
                                821.35,
                                751.79,
                                0
                            ],
                            [
                                832.99,
                                751.77,
                                0
                            ],
                            [
                                848.54,
                                751.74,
                                0
                            ],
                            [
                                856.75,
                                751.73,
                                0
                            ],
                            [
                                872.22,
                                751.7,
                                0
                            ],
                            [
                                887.63,
                                751.68,
                                0
                            ],
                            [
                                898.58,
                                751.68,
                                0
                            ],
                            [
                                913.63,
                                751.68,
                                0
                            ],
                            [
                                931.93,
                                751.68,
                                0
                            ],
                            [
                                946.71,
                                751.68,
                                0
                            ],
                            [
                                951.79,
                                751.68,
                                0
                            ],
                            [
                                962.28,
                                751.68,
                                0
                            ],
                            [
                                975.08,
                                751.68,
                                0
                            ],
                            [
                                985.43,
                                751.68,
                                0
                            ],
                            [
                                993.21,
                                751.7,
                                0
                            ],
                            [
                                1005.79,
                                751.74,
                                0
                            ],
                            [
                                1016.67,
                                751.77,
                                0
                            ],
                            [
                                1036.06,
                                751.82,
                                0
                            ],
                            [
                                1046.95,
                                751.85,
                                0
                            ],
                            [
                                1058.37,
                                751.88,
                                0
                            ],
                            [
                                1080.4,
                                751.94,
                                0
                            ],
                            [
                                1091.84,
                                751.97,
                                0
                            ],
                            [
                                1114.36,
                                752.03,
                                0
                            ],
                            [
                                1134.36,
                                752.09,
                                0
                            ],
                            [
                                1146.79,
                                752.11,
                                0
                            ],
                            [
                                1160.18,
                                752.13,
                                0
                            ],
                            [
                                1173.88,
                                752.15,
                                0
                            ],
                            [
                                1190.71,
                                752.17,
                                0
                            ],
                            [
                                1210.27,
                                752.2,
                                0
                            ],
                            [
                                1232.26,
                                752.23,
                                0
                            ],
                            [
                                1250.64,
                                752.26,
                                0
                            ],
                            [
                                1273.67,
                                752.29,
                                0
                            ],
                            [
                                1276.31,
                                752.3,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                0,
                                751.88,
                                0
                            ],
                            [
                                10.35,
                                751.88,
                                0
                            ],
                            [
                                27.53,
                                751.88,
                                0
                            ],
                            [
                                60.33,
                                751.88,
                                0
                            ],
                            [
                                140.33,
                                751.88,
                                0
                            ],
                            [
                                141.44,
                                751.88,
                                0
                            ],
                            [
                                328.33,
                                751.88,
                                748.38
                            ],
                            [
                                408.39,
                                751.88,
                                748.38
                            ],
                            [
                                419.28,
                                751.85,
                                0
                            ],
                            [
                                430.7,
                                751.88,
                                0
                            ],
                            [
                                452.73,
                                751.94,
                                0
                            ],
                            [
                                464.17,
                                751.97,
                                0
                            ],
                            [
                                486.69,
                                752.03,
                                0
                            ],
                            [
                                506.69,
                                752.09,
                                0
                            ],
                            [
                                519.12,
                                752.11,
                                0
                            ],
                            [
                                532.51,
                                752.13,
                                0
                            ],
                            [
                                546.21,
                                752.15,
                                0
                            ],
                            [
                                563.04,
                                752.17,
                                0
                            ],
                            [
                                582.6,
                                752.2,
                                0
                            ],
                            [
                                604.59,
                                752.23,
                                0
                            ],
                            [
                                622.97,
                                752.26,
                                0
                            ],
                            [
                                646,
                                752.29,
                                0
                            ],
                            [
                                648.64,
                                752.3,
                                0
                            ],
                            [
                                1020.33,
                                752.3,
                                0
                            ]
                        ]
                    }
                },
                "deck_dist_diff": [
                    {
                        "name": "Chord Station Elevation Data",
                        "base": "*",
                        "compare": "*"
                    }
                ],
                "abutment_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                },
                "pier_diff": {
                    "has_diff": true,
                    "diff": [
                        {
                            "name": "Pier#1",
                            "diffs": [
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "634.6",
                                    "compare": "355"
                                }
                            ]
                        },
                        {
                            "name": "Pier#2",
                            "diffs": [
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "661.3",
                                    "compare": "381.67"
                                }
                            ]
                        }
                    ],
                    "added": [],
                    "removed": []
                },
                "culvert_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                }
            },
            {
                "cross_section": 55431,
                "type": "Bridge",
                "deck_dist_data": {
                    "base_title": "Existing",
                    "compare_title": "Multiple Run",
                    "base": {
                        "distance": 150,
                        "width": 13,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                0,
                                732.39,
                                0
                            ],
                            [
                                489,
                                732.39,
                                0
                            ],
                            [
                                489.19,
                                732.39,
                                730.39
                            ],
                            [
                                504.66,
                                732.55,
                                730.39
                            ],
                            [
                                512.13,
                                732.66,
                                730.55
                            ],
                            [
                                514.01,
                                732.56,
                                730.66
                            ],
                            [
                                532.56,
                                732.89,
                                730.56
                            ],
                            [
                                534.83,
                                732.82,
                                730.89
                            ],
                            [
                                538.5,
                                731.89,
                                730.82
                            ],
                            [
                                555.19,
                                732.35,
                                729.89
                            ],
                            [
                                558.69,
                                732.61,
                                730.35
                            ],
                            [
                                574.65,
                                733.09,
                                730.61
                            ],
                            [
                                591.71,
                                733.6,
                                731.09
                            ],
                            [
                                593.84,
                                733.73,
                                731.6
                            ],
                            [
                                625.47,
                                734.5,
                                731.73
                            ],
                            [
                                626.33,
                                734.56,
                                732.5
                            ],
                            [
                                626.78,
                                734.59,
                                732.56
                            ],
                            [
                                627.48,
                                734.28,
                                732.59
                            ],
                            [
                                666.89,
                                735.25,
                                733.29
                            ],
                            [
                                669.68,
                                735.29,
                                733.58
                            ],
                            [
                                690.98,
                                735.58,
                                733.92
                            ],
                            [
                                715.06,
                                735.92,
                                734.26
                            ],
                            [
                                736.05,
                                736.26,
                                734.6
                            ],
                            [
                                757.05,
                                736.6,
                                734.9
                            ],
                            [
                                772.42,
                                736.9,
                                735.24
                            ],
                            [
                                796.8,
                                737.24,
                                0
                            ],
                            [
                                821.18,
                                737.58,
                                0
                            ],
                            [
                                845.95,
                                736.84,
                                0
                            ],
                            [
                                846.26,
                                736.81,
                                0
                            ],
                            [
                                849.45,
                                736.88,
                                0
                            ],
                            [
                                872.11,
                                738.89,
                                0
                            ],
                            [
                                907.55,
                                739.78,
                                0
                            ],
                            [
                                922.41,
                                739.57,
                                0
                            ],
                            [
                                922.47,
                                739.57,
                                0
                            ],
                            [
                                937.9,
                                739.86,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                379,
                                732.39,
                                0
                            ],
                            [
                                379.19,
                                732.39,
                                0
                            ],
                            [
                                394.66,
                                732.55,
                                0
                            ],
                            [
                                402.13,
                                732.66,
                                0
                            ],
                            [
                                404.01,
                                732.56,
                                0
                            ],
                            [
                                422.56,
                                732.89,
                                0
                            ],
                            [
                                424.83,
                                732.82,
                                0
                            ],
                            [
                                431,
                                731.89,
                                729.89
                            ],
                            [
                                445.19,
                                732.35,
                                730.35
                            ],
                            [
                                448.69,
                                732.61,
                                730.61
                            ],
                            [
                                464.65,
                                733.09,
                                731.09
                            ],
                            [
                                481.71,
                                733.6,
                                731.6
                            ],
                            [
                                483.84,
                                733.73,
                                731.73
                            ],
                            [
                                515.47,
                                734.5,
                                732.5
                            ],
                            [
                                516.33,
                                734.56,
                                732.56
                            ],
                            [
                                516.78,
                                734.59,
                                732.59
                            ],
                            [
                                517.48,
                                734.28,
                                732.28
                            ],
                            [
                                556.89,
                                735.25,
                                733.58
                            ],
                            [
                                559.68,
                                735.29,
                                733.92
                            ],
                            [
                                580.98,
                                735.58,
                                734.26
                            ],
                            [
                                605.06,
                                735.92,
                                734.6
                            ],
                            [
                                626.05,
                                736.26,
                                734.9
                            ],
                            [
                                647.05,
                                736.6,
                                735.24
                            ],
                            [
                                739.45,
                                736.88,
                                735.24
                            ],
                            [
                                762.11,
                                738.89,
                                0
                            ],
                            [
                                797.55,
                                739.78,
                                0
                            ],
                            [
                                812.41,
                                739.57,
                                0
                            ],
                            [
                                812.47,
                                739.57,
                                0
                            ],
                            [
                                827.9,
                                739.86,
                                0
                            ]
                        ]
                    },
                    "cmp": {
                        "distance": 8,
                        "width": 10,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                0,
                                733.83,
                                0
                            ],
                            [
                                113.137,
                                733.83,
                                0
                            ],
                            [
                                128.34,
                                732.92,
                                730.22
                            ],
                            [
                                202.233,
                                734.15,
                                731.45
                            ],
                            [
                                264.104,
                                735.22,
                                732.52
                            ],
                            [
                                337.856,
                                736.7,
                                734
                            ],
                            [
                                360.2,
                                737.13,
                                0
                            ],
                            [
                                392.586,
                                738.26,
                                0
                            ],
                            [
                                426.598,
                                739.55,
                                0
                            ],
                            [
                                460.256,
                                740.64,
                                0
                            ],
                            [
                                502.329,
                                742.13,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                0,
                                733.83,
                                0
                            ],
                            [
                                109.884,
                                733.83,
                                0
                            ],
                            [
                                141.421,
                                732.92,
                                730.22
                            ],
                            [
                                213.829,
                                734.15,
                                731.45
                            ],
                            [
                                275.56,
                                735.22,
                                732.52
                            ],
                            [
                                339.906,
                                736.7,
                                734
                            ],
                            [
                                355.533,
                                737.13,
                                0
                            ],
                            [
                                389.687,
                                738.26,
                                0
                            ],
                            [
                                430.062,
                                739.55,
                                0
                            ],
                            [
                                461.882,
                                740.64,
                                0
                            ],
                            [
                                501.197,
                                742.13,
                                0
                            ]
                        ]
                    }
                },
                "deck_dist_diff": [
                    {
                        "name": "Distance",
                        "base": "150",
                        "compare": "8"
                    },
                    {
                        "name": "Width",
                        "base": "13",
                        "compare": "10"
                    },
                    {
                        "name": "Chord Station Elevation Data",
                        "base": "*",
                        "compare": "*"
                    }
                ],
                "abutment_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                },
                "pier_diff": {
                    "has_diff": true,
                    "diff": [
                        {
                            "name": "Pier#1",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "500",
                                    "compare": "137.497"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "443",
                                    "compare": "153.301"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#2",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "512",
                                    "compare": "146.124"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "455",
                                    "compare": "161.927"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#3",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "524",
                                    "compare": "155.74"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "467",
                                    "compare": "170.554"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#4",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "536",
                                    "compare": "164.862"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "479",
                                    "compare": "179.181"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#5",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "548",
                                    "compare": "173.984"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "491",
                                    "compare": "187.808"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#6",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "560",
                                    "compare": "183.105"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "503",
                                    "compare": "196.717"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#7",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "572",
                                    "compare": "192.227"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "515",
                                    "compare": "204.354"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#8",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "584",
                                    "compare": "201.349"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "527",
                                    "compare": "213.688"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#9",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "596",
                                    "compare": "210.47"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "539",
                                    "compare": "222.314"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#10",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "608",
                                    "compare": "219.592"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "551",
                                    "compare": "230.941"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#11",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "620",
                                    "compare": "228.714"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "563",
                                    "compare": "239.568"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#12",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "632",
                                    "compare": "237.835"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "575",
                                    "compare": "248.194"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#13",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "644",
                                    "compare": "246.957"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "587",
                                    "compare": "256.821"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#14",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "656",
                                    "compare": "256.079"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "599",
                                    "compare": "265.448"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#15",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "668",
                                    "compare": "265.2"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "611",
                                    "compare": "274.075"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#16",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "680",
                                    "compare": "274.322"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "623",
                                    "compare": "282.701"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#17",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "692",
                                    "compare": "283.444"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "635",
                                    "compare": "294.581"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#18",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "704",
                                    "compare": "292.565"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "647",
                                    "compare": "303.207"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#19",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "716",
                                    "compare": "301.687"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "659",
                                    "compare": "311.834"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#20",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "728",
                                    "compare": "310.809"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "671",
                                    "compare": "320.461"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#21",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "740",
                                    "compare": "319.435"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "683",
                                    "compare": "329.087"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#22",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "752",
                                    "compare": "328.557"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "695",
                                    "compare": "337.714"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        }
                    ],
                    "added": [],
                    "removed": [
                        {
                            "name": "Pier#23",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#24",
                            "plan": "Multiple Run"
                        }
                    ]
                },
                "culvert_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                }
            },
            {
                "cross_section": 55210,
                "type": "Bridge",
                "deck_dist_data": {
                    "base_title": "Existing",
                    "compare_title": "Multiple Run",
                    "base": {
                        "distance": 13,
                        "width": 12,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                223,
                                736.66,
                                0
                            ],
                            [
                                239.81,
                                735.78,
                                0
                            ],
                            [
                                284.28,
                                733.38,
                                0
                            ],
                            [
                                337.68,
                                733.19,
                                0
                            ],
                            [
                                356.8,
                                732.74,
                                0
                            ],
                            [
                                372.67,
                                732.91,
                                0
                            ],
                            [
                                385.89,
                                732.82,
                                0
                            ],
                            [
                                401.46,
                                732.2,
                                0
                            ],
                            [
                                418.06,
                                730.35,
                                0
                            ],
                            [
                                426.94,
                                729.5,
                                727.54
                            ],
                            [
                                440.23,
                                729.54,
                                727.55
                            ],
                            [
                                446.76,
                                729.55,
                                727.56
                            ],
                            [
                                461.86,
                                729.56,
                                727.58
                            ],
                            [
                                483.45,
                                729.58,
                                727.58
                            ],
                            [
                                487.2,
                                729.58,
                                727.58
                            ],
                            [
                                512.55,
                                729.6,
                                727.6
                            ],
                            [
                                527.38,
                                730.02,
                                0
                            ],
                            [
                                550.99,
                                730.24,
                                0
                            ],
                            [
                                572.8,
                                730.14,
                                0
                            ],
                            [
                                579.27,
                                729.97,
                                0
                            ],
                            [
                                584.49,
                                730.22,
                                0
                            ],
                            [
                                588.57,
                                730.31,
                                0
                            ],
                            [
                                613.38,
                                731.2,
                                0
                            ],
                            [
                                674.16,
                                732.53,
                                0
                            ],
                            [
                                679.3,
                                732.65,
                                0
                            ],
                            [
                                683.62,
                                732.75,
                                0
                            ],
                            [
                                685.61,
                                732.75,
                                0
                            ],
                            [
                                686.12,
                                732.75,
                                0
                            ],
                            [
                                687.38,
                                732.75,
                                0
                            ],
                            [
                                688.62,
                                732.75,
                                0
                            ],
                            [
                                689.61,
                                732.55,
                                0
                            ],
                            [
                                693.11,
                                731.86,
                                0
                            ],
                            [
                                694.62,
                                731.79,
                                0
                            ],
                            [
                                733.27,
                                731.71,
                                0
                            ],
                            [
                                741.12,
                                731.69,
                                0
                            ],
                            [
                                755.31,
                                730.92,
                                0
                            ],
                            [
                                764.92,
                                730.4,
                                0
                            ],
                            [
                                771.44,
                                732.77,
                                0
                            ],
                            [
                                771.67,
                                732.82,
                                0
                            ],
                            [
                                791.04,
                                734.75,
                                0
                            ],
                            [
                                806.54,
                                735.36,
                                0
                            ],
                            [
                                817.69,
                                735.41,
                                0
                            ],
                            [
                                831.9,
                                735.89,
                                0
                            ],
                            [
                                846.53,
                                736.27,
                                0
                            ],
                            [
                                855.7,
                                736.13,
                                0
                            ],
                            [
                                871.89,
                                735.96,
                                0
                            ],
                            [
                                874.69,
                                735.73,
                                0
                            ],
                            [
                                878.17,
                                735.4,
                                0
                            ],
                            [
                                899.29,
                                734.84,
                                0
                            ],
                            [
                                903.11,
                                734.31,
                                0
                            ],
                            [
                                906.19,
                                734.03,
                                0
                            ],
                            [
                                910.17,
                                733.48,
                                0
                            ],
                            [
                                913.32,
                                733.21,
                                0
                            ],
                            [
                                916.2,
                                732.86,
                                0
                            ],
                            [
                                944.47,
                                731.32,
                                0
                            ],
                            [
                                946.46,
                                731.09,
                                0
                            ],
                            [
                                952.85,
                                730.66,
                                0
                            ],
                            [
                                954.03,
                                730.51,
                                0
                            ],
                            [
                                971.49,
                                730.92,
                                0
                            ],
                            [
                                990.12,
                                730.84,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                238,
                                736.66,
                                0
                            ],
                            [
                                254.81,
                                735.78,
                                0
                            ],
                            [
                                299.28,
                                733.38,
                                0
                            ],
                            [
                                352.68,
                                733.19,
                                0
                            ],
                            [
                                371.8,
                                732.74,
                                0
                            ],
                            [
                                387.67,
                                732.91,
                                0
                            ],
                            [
                                400.89,
                                732.82,
                                0
                            ],
                            [
                                416.46,
                                732.2,
                                0
                            ],
                            [
                                433.06,
                                730.35,
                                0
                            ],
                            [
                                441.94,
                                729.5,
                                727.5
                            ],
                            [
                                455.23,
                                729.54,
                                727.54
                            ],
                            [
                                461.76,
                                729.55,
                                727.55
                            ],
                            [
                                476.86,
                                729.56,
                                727.56
                            ],
                            [
                                498.45,
                                729.58,
                                727.58
                            ],
                            [
                                502.2,
                                729.58,
                                727.58
                            ],
                            [
                                527.55,
                                729.6,
                                727.6
                            ],
                            [
                                542.38,
                                730.02,
                                0
                            ],
                            [
                                565.99,
                                730.24,
                                0
                            ],
                            [
                                587.8,
                                730.14,
                                0
                            ],
                            [
                                594.27,
                                729.97,
                                0
                            ],
                            [
                                599.49,
                                730.22,
                                0
                            ],
                            [
                                603.57,
                                730.31,
                                0
                            ],
                            [
                                628.38,
                                731.2,
                                0
                            ],
                            [
                                689.16,
                                732.53,
                                0
                            ],
                            [
                                694.3,
                                732.65,
                                0
                            ],
                            [
                                698.62,
                                732.75,
                                0
                            ],
                            [
                                700.61,
                                732.75,
                                0
                            ],
                            [
                                701.12,
                                732.75,
                                0
                            ],
                            [
                                702.38,
                                732.75,
                                0
                            ],
                            [
                                703.62,
                                732.75,
                                0
                            ],
                            [
                                704.61,
                                732.55,
                                0
                            ],
                            [
                                708.11,
                                731.86,
                                0
                            ],
                            [
                                709.62,
                                731.79,
                                0
                            ],
                            [
                                748.27,
                                731.71,
                                0
                            ],
                            [
                                756.12,
                                731.69,
                                0
                            ],
                            [
                                770.31,
                                730.92,
                                0
                            ],
                            [
                                779.92,
                                730.4,
                                0
                            ],
                            [
                                786.44,
                                732.77,
                                0
                            ],
                            [
                                786.67,
                                732.82,
                                0
                            ],
                            [
                                806.04,
                                734.75,
                                0
                            ],
                            [
                                821.54,
                                735.36,
                                0
                            ],
                            [
                                832.69,
                                735.41,
                                0
                            ],
                            [
                                846.9,
                                735.89,
                                0
                            ],
                            [
                                861.53,
                                736.27,
                                0
                            ],
                            [
                                870.7,
                                736.13,
                                0
                            ],
                            [
                                886.89,
                                735.96,
                                0
                            ],
                            [
                                889.69,
                                735.73,
                                0
                            ],
                            [
                                893.17,
                                735.4,
                                0
                            ],
                            [
                                914.29,
                                734.84,
                                0
                            ],
                            [
                                918.11,
                                734.31,
                                0
                            ],
                            [
                                921.19,
                                734.03,
                                0
                            ],
                            [
                                925.17,
                                733.48,
                                0
                            ],
                            [
                                928.32,
                                733.21,
                                0
                            ],
                            [
                                931.2,
                                732.86,
                                0
                            ],
                            [
                                959.47,
                                731.32,
                                0
                            ],
                            [
                                961.46,
                                731.09,
                                0
                            ],
                            [
                                967.85,
                                730.66,
                                0
                            ],
                            [
                                969.03,
                                730.51,
                                0
                            ],
                            [
                                986.49,
                                730.92,
                                0
                            ],
                            [
                                1005.12,
                                730.84,
                                0
                            ]
                        ]
                    },
                    "cmp": {
                        "distance": 6,
                        "width": 13,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                180.03,
                                729.34,
                                727.64
                            ],
                            [
                                266.92,
                                729.51,
                                727.81
                            ],
                            [
                                281.35,
                                729.48,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                180.03,
                                729.34,
                                727.64
                            ],
                            [
                                266.92,
                                729.51,
                                727.81
                            ],
                            [
                                281.35,
                                729.48,
                                0
                            ]
                        ]
                    }
                },
                "deck_dist_diff": [
                    {
                        "name": "Distance",
                        "base": "13",
                        "compare": "6"
                    },
                    {
                        "name": "Width",
                        "base": "12",
                        "compare": "13"
                    },
                    {
                        "name": "Chord Station Elevation Data",
                        "base": "*",
                        "compare": "*"
                    }
                ],
                "abutment_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                },
                "pier_diff": {
                    "has_diff": true,
                    "diff": [
                        {
                            "name": "Pier#1",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "448",
                                    "compare": "201.75"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "463",
                                    "compare": "201.75"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#2",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "469",
                                    "compare": "223.48"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "484",
                                    "compare": "223.48"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#3",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "490",
                                    "compare": "245.2"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "505",
                                    "compare": "245.2"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        }
                    ],
                    "added": [],
                    "removed": []
                },
                "culvert_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                }
            },
            {
                "cross_section": 55013,
                "type": "Bridge",
                "deck_dist_data": {
                    "base_title": "Existing",
                    "compare_title": "Multiple Run",
                    "base": {
                        "distance": 30,
                        "width": 12,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                225,
                                732.99,
                                0
                            ],
                            [
                                255.82,
                                731.77,
                                0
                            ],
                            [
                                312.82,
                                731.7,
                                0
                            ],
                            [
                                370.26,
                                732.41,
                                0
                            ],
                            [
                                399.95,
                                732.79,
                                0
                            ],
                            [
                                409.16,
                                732.25,
                                0
                            ],
                            [
                                428.91,
                                731.6,
                                0
                            ],
                            [
                                459.89,
                                729.49,
                                0
                            ],
                            [
                                490.79,
                                731.17,
                                729.67
                            ],
                            [
                                514.52,
                                731.9,
                                730.4
                            ],
                            [
                                518.3,
                                732.02,
                                730.52
                            ],
                            [
                                538.25,
                                732.63,
                                731.13
                            ],
                            [
                                549,
                                732.96,
                                731.46
                            ],
                            [
                                561.98,
                                733.36,
                                0
                            ],
                            [
                                585.71,
                                734.09,
                                0
                            ],
                            [
                                588.25,
                                724.67,
                                0
                            ],
                            [
                                611.69,
                                725.06,
                                0
                            ],
                            [
                                631.5,
                                725.56,
                                0
                            ],
                            [
                                650.98,
                                725.93,
                                0
                            ],
                            [
                                684.03,
                                728.34,
                                0
                            ],
                            [
                                703.99,
                                729.99,
                                0
                            ],
                            [
                                704.75,
                                735.07,
                                0
                            ],
                            [
                                728.27,
                                729.44,
                                0
                            ],
                            [
                                738.12,
                                730.52,
                                0
                            ],
                            [
                                745.28,
                                730.67,
                                0
                            ],
                            [
                                823.84,
                                735.96,
                                0
                            ],
                            [
                                827.7,
                                736.81,
                                0
                            ],
                            [
                                871.29,
                                734.03,
                                0
                            ],
                            [
                                898.81,
                                732.98,
                                0
                            ],
                            [
                                908.87,
                                732.75,
                                0
                            ],
                            [
                                929.83,
                                732.22,
                                0
                            ],
                            [
                                948.6,
                                732.07,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                200,
                                732.99,
                                0
                            ],
                            [
                                258,
                                732.99,
                                0
                            ],
                            [
                                288.82,
                                731.77,
                                0
                            ],
                            [
                                345.82,
                                731.7,
                                0
                            ],
                            [
                                403.26,
                                732.41,
                                0
                            ],
                            [
                                432.95,
                                732.79,
                                0
                            ],
                            [
                                442.16,
                                732.25,
                                0
                            ],
                            [
                                461.91,
                                731.6,
                                0
                            ],
                            [
                                492.89,
                                729.49,
                                0
                            ],
                            [
                                523.79,
                                731.17,
                                730.02
                            ],
                            [
                                547.52,
                                731.9,
                                730.63
                            ],
                            [
                                551.3,
                                732.02,
                                730.96
                            ],
                            [
                                571.25,
                                732.63,
                                731.36
                            ],
                            [
                                582,
                                732.96,
                                732.09
                            ],
                            [
                                594.98,
                                733.36,
                                0
                            ],
                            [
                                618.71,
                                734.09,
                                0
                            ],
                            [
                                621.25,
                                724.67,
                                0
                            ],
                            [
                                644.69,
                                725.06,
                                0
                            ],
                            [
                                664.5,
                                725.56,
                                0
                            ],
                            [
                                683.98,
                                725.93,
                                0
                            ],
                            [
                                717.03,
                                728.34,
                                0
                            ],
                            [
                                736.99,
                                729.99,
                                0
                            ],
                            [
                                737.75,
                                735.07,
                                0
                            ],
                            [
                                761.27,
                                729.44,
                                0
                            ],
                            [
                                771.12,
                                730.52,
                                0
                            ],
                            [
                                778.28,
                                730.67,
                                0
                            ],
                            [
                                856.84,
                                735.96,
                                0
                            ],
                            [
                                860.7,
                                736.81,
                                0
                            ],
                            [
                                904.29,
                                734.03,
                                0
                            ],
                            [
                                931.81,
                                732.98,
                                0
                            ],
                            [
                                941.87,
                                732.75,
                                0
                            ],
                            [
                                962.83,
                                732.22,
                                0
                            ],
                            [
                                981.6,
                                732.07,
                                0
                            ]
                        ]
                    },
                    "cmp": {
                        "distance": 4,
                        "width": 10,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                139.79,
                                731.26,
                                729.56
                            ],
                            [
                                236.88,
                                733.96,
                                732.26
                            ]
                        ],
                        "station_table_ds": [
                            [
                                159.79,
                                731.26,
                                729.56
                            ],
                            [
                                256.88,
                                733.96,
                                732.26
                            ]
                        ]
                    }
                },
                "deck_dist_diff": [
                    {
                        "name": "Distance",
                        "base": "30",
                        "compare": "4"
                    },
                    {
                        "name": "Width",
                        "base": "12",
                        "compare": "10"
                    },
                    {
                        "name": "Chord Station Elevation Data",
                        "base": "*",
                        "compare": "*"
                    }
                ],
                "abutment_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                },
                "pier_diff": {
                    "has_diff": true,
                    "diff": [],
                    "added": [
                        {
                            "name": "Pier#1",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#2",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#3",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#4",
                            "plan": "Multiple Run"
                        }
                    ],
                    "removed": []
                },
                "culvert_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                }
            },
            {
                "cross_section": 54311,
                "type": "Bridge",
                "deck_dist_data": {
                    "base_title": "Existing",
                    "compare_title": "Multiple Run",
                    "base": {
                        "distance": 28,
                        "width": 10,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                436,
                                730.84,
                                0
                            ],
                            [
                                439.51,
                                730.85,
                                0
                            ],
                            [
                                475.93,
                                730.81,
                                0
                            ],
                            [
                                512.35,
                                730.77,
                                0
                            ],
                            [
                                533.43,
                                730.71,
                                0
                            ],
                            [
                                554.51,
                                730.64,
                                0
                            ],
                            [
                                584.54,
                                730.55,
                                0
                            ],
                            [
                                614.56,
                                730.46,
                                0
                            ],
                            [
                                629.44,
                                730.37,
                                0
                            ],
                            [
                                644.32,
                                730.29,
                                728.29
                            ],
                            [
                                660.68,
                                730.2,
                                728.2
                            ],
                            [
                                674.08,
                                730.12,
                                728.12
                            ],
                            [
                                702.04,
                                729.04,
                                727.04
                            ],
                            [
                                717,
                                729.94,
                                727.94
                            ],
                            [
                                721.81,
                                730.18,
                                0
                            ],
                            [
                                722.66,
                                730.41,
                                0
                            ],
                            [
                                725.47,
                                730.35,
                                0
                            ],
                            [
                                730.65,
                                730.49,
                                0
                            ],
                            [
                                754.07,
                                730.81,
                                0
                            ],
                            [
                                759.06,
                                730.87,
                                0
                            ],
                            [
                                773.34,
                                731.16,
                                0
                            ],
                            [
                                792.97,
                                732.29,
                                0
                            ],
                            [
                                812.8,
                                732.51,
                                0
                            ],
                            [
                                832.63,
                                732.73,
                                0
                            ],
                            [
                                854.07,
                                733.33,
                                0
                            ],
                            [
                                855.11,
                                733.12,
                                0
                            ],
                            [
                                856.47,
                                737.74,
                                0
                            ],
                            [
                                856.88,
                                737.66,
                                0
                            ],
                            [
                                874.12,
                                743.86,
                                0
                            ],
                            [
                                877.42,
                                745.09,
                                0
                            ],
                            [
                                879.69,
                                745.73,
                                0
                            ],
                            [
                                912.32,
                                752.11,
                                0
                            ],
                            [
                                913.45,
                                752.33,
                                0
                            ],
                            [
                                913.49,
                                752.33,
                                0
                            ],
                            [
                                948.8,
                                756.82,
                                0
                            ],
                            [
                                950.15,
                                756.94,
                                0
                            ],
                            [
                                974.64,
                                759.97,
                                0
                            ],
                            [
                                985.18,
                                761.2,
                                0
                            ],
                            [
                                1001.49,
                                762.45,
                                0
                            ],
                            [
                                1012.43,
                                763.68,
                                0
                            ],
                            [
                                1025.08,
                                765.25,
                                0
                            ],
                            [
                                1046.15,
                                766.62,
                                0
                            ],
                            [
                                1056.04,
                                767.49,
                                0
                            ],
                            [
                                1067.01,
                                767.52,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                315,
                                730.84,
                                0
                            ],
                            [
                                318.51,
                                730.85,
                                0
                            ],
                            [
                                354.93,
                                730.81,
                                0
                            ],
                            [
                                391.35,
                                730.77,
                                0
                            ],
                            [
                                412.43,
                                730.71,
                                0
                            ],
                            [
                                433.51,
                                730.64,
                                0
                            ],
                            [
                                463.54,
                                730.55,
                                0
                            ],
                            [
                                493.56,
                                730.46,
                                0
                            ],
                            [
                                508.44,
                                730.37,
                                0
                            ],
                            [
                                512,
                                730.29,
                                728.29
                            ],
                            [
                                539.68,
                                730.2,
                                728.2
                            ],
                            [
                                553.08,
                                730.12,
                                728.12
                            ],
                            [
                                584.82,
                                729.94,
                                727.94
                            ],
                            [
                                600.81,
                                730.18,
                                0
                            ],
                            [
                                601.66,
                                730.41,
                                0
                            ],
                            [
                                604.47,
                                730.35,
                                0
                            ],
                            [
                                609.65,
                                730.49,
                                0
                            ],
                            [
                                633.07,
                                730.81,
                                0
                            ],
                            [
                                638.06,
                                730.87,
                                0
                            ],
                            [
                                652.34,
                                731.16,
                                0
                            ],
                            [
                                671.97,
                                732.29,
                                0
                            ],
                            [
                                691.8,
                                732.51,
                                0
                            ],
                            [
                                711.63,
                                732.73,
                                0
                            ],
                            [
                                733.07,
                                733.33,
                                0
                            ],
                            [
                                734.11,
                                733.12,
                                0
                            ],
                            [
                                735.47,
                                737.74,
                                0
                            ],
                            [
                                735.88,
                                737.66,
                                0
                            ],
                            [
                                753.12,
                                743.86,
                                0
                            ],
                            [
                                756.42,
                                745.09,
                                0
                            ],
                            [
                                758.69,
                                745.73,
                                0
                            ],
                            [
                                791.32,
                                752.11,
                                0
                            ],
                            [
                                792.45,
                                752.33,
                                0
                            ],
                            [
                                792.49,
                                752.33,
                                0
                            ],
                            [
                                827.8,
                                756.82,
                                0
                            ],
                            [
                                829.15,
                                756.94,
                                0
                            ],
                            [
                                853.64,
                                759.97,
                                0
                            ],
                            [
                                864.18,
                                761.2,
                                0
                            ],
                            [
                                880.49,
                                762.45,
                                0
                            ],
                            [
                                891.43,
                                763.68,
                                0
                            ],
                            [
                                904.08,
                                765.25,
                                0
                            ],
                            [
                                925.15,
                                766.62,
                                0
                            ],
                            [
                                935.04,
                                767.49,
                                0
                            ],
                            [
                                946.01,
                                767.52,
                                0
                            ]
                        ]
                    },
                    "cmp": {
                        "distance": 5,
                        "width": 10,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                189.92,
                                730.85,
                                0
                            ],
                            [
                                200,
                                730.89,
                                728.19
                            ],
                            [
                                404,
                                729.87,
                                727.17
                            ],
                            [
                                410.31,
                                729.98,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                100,
                                730.89,
                                728.19
                            ],
                            [
                                270,
                                729.87,
                                727.17
                            ]
                        ]
                    }
                },
                "deck_dist_diff": [
                    {
                        "name": "Distance",
                        "base": "28",
                        "compare": "5"
                    },
                    {
                        "name": "Chord Station Elevation Data",
                        "base": "*",
                        "compare": "*"
                    }
                ],
                "abutment_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                },
                "pier_diff": {
                    "has_diff": true,
                    "diff": [
                        {
                            "name": "Pier#1",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "654",
                                    "compare": "212"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "522",
                                    "compare": "0"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#2",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "664",
                                    "compare": "224"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "532",
                                    "compare": "0"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#3",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "674",
                                    "compare": "236"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "542",
                                    "compare": "106"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#4",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "684",
                                    "compare": "248"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "552",
                                    "compare": "118"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#5",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "694",
                                    "compare": "260"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "562",
                                    "compare": "126"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#6",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "704",
                                    "compare": "272"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "572",
                                    "compare": "142"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        }
                    ],
                    "added": [
                        {
                            "name": "Pier#7",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#8",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#9",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#10",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#11",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#12",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#13",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#14",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#15",
                            "plan": "Multiple Run"
                        },
                        {
                            "name": "Pier#16",
                            "plan": "Multiple Run"
                        }
                    ],
                    "removed": []
                },
                "culvert_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                }
            },
            {
                "cross_section": 54254,
                "type": "Bridge",
                "deck_dist_data": {
                    "base_title": "Existing",
                    "compare_title": "Multiple Run",
                    "base": {
                        "distance": 15,
                        "width": 12,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                364,
                                729.94,
                                0
                            ],
                            [
                                371.92,
                                729.84,
                                0
                            ],
                            [
                                377,
                                729.76,
                                0
                            ],
                            [
                                387.45,
                                730.75,
                                0
                            ],
                            [
                                411.39,
                                730.08,
                                0
                            ],
                            [
                                411.62,
                                730,
                                0
                            ],
                            [
                                430.11,
                                729.06,
                                0
                            ],
                            [
                                464.58,
                                727.22,
                                0
                            ],
                            [
                                492.1,
                                726.38,
                                0
                            ],
                            [
                                509.21,
                                726.38,
                                0
                            ],
                            [
                                514.37,
                                725.4,
                                723.6
                            ],
                            [
                                540.45,
                                726.6,
                                724.8
                            ],
                            [
                                553.28,
                                727.19,
                                725.39
                            ],
                            [
                                569.41,
                                727.94,
                                726.14
                            ],
                            [
                                583.6,
                                728.61,
                                726.81
                            ],
                            [
                                602.79,
                                729.66,
                                727.86
                            ],
                            [
                                608.53,
                                730,
                                0
                            ],
                            [
                                628.01,
                                730.33,
                                0
                            ],
                            [
                                649.42,
                                730.99,
                                0
                            ],
                            [
                                660.12,
                                731.32,
                                0
                            ],
                            [
                                670.82,
                                731.64,
                                0
                            ],
                            [
                                681.35,
                                731.92,
                                0
                            ],
                            [
                                691.89,
                                732.2,
                                0
                            ],
                            [
                                712.95,
                                732.76,
                                0
                            ],
                            [
                                720.4,
                                732.45,
                                0
                            ],
                            [
                                731.14,
                                732.5,
                                0
                            ],
                            [
                                743.91,
                                732.31,
                                0
                            ],
                            [
                                744.97,
                                734.73,
                                0
                            ],
                            [
                                746.03,
                                737.16,
                                0
                            ],
                            [
                                753.37,
                                739.89,
                                0
                            ],
                            [
                                764.81,
                                743.07,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                155,
                                729.94,
                                0
                            ],
                            [
                                162.92,
                                729.84,
                                0
                            ],
                            [
                                168,
                                729.76,
                                0
                            ],
                            [
                                178.45,
                                730.75,
                                0
                            ],
                            [
                                202.39,
                                730.08,
                                0
                            ],
                            [
                                202.62,
                                730,
                                0
                            ],
                            [
                                221.11,
                                729.06,
                                0
                            ],
                            [
                                255.58,
                                727.22,
                                0
                            ],
                            [
                                283.1,
                                726.38,
                                0
                            ],
                            [
                                300.21,
                                726.38,
                                0
                            ],
                            [
                                305.37,
                                725.4,
                                723.6
                            ],
                            [
                                331.45,
                                726.6,
                                724.8
                            ],
                            [
                                344.28,
                                727.19,
                                725.39
                            ],
                            [
                                360.41,
                                727.94,
                                726.14
                            ],
                            [
                                374.6,
                                728.61,
                                726.81
                            ],
                            [
                                393.79,
                                729.66,
                                727.86
                            ],
                            [
                                399.53,
                                730,
                                0
                            ],
                            [
                                419.01,
                                730.33,
                                0
                            ],
                            [
                                440.42,
                                730.99,
                                0
                            ],
                            [
                                451.12,
                                731.32,
                                0
                            ],
                            [
                                461.82,
                                731.64,
                                0
                            ],
                            [
                                472.35,
                                731.92,
                                0
                            ],
                            [
                                482.89,
                                732.2,
                                0
                            ],
                            [
                                503.95,
                                732.76,
                                0
                            ],
                            [
                                511.4,
                                732.45,
                                0
                            ],
                            [
                                522.14,
                                732.5,
                                0
                            ],
                            [
                                534.91,
                                732.31,
                                0
                            ],
                            [
                                535.97,
                                734.73,
                                0
                            ],
                            [
                                537.03,
                                737.16,
                                0
                            ],
                            [
                                544.37,
                                739.89,
                                0
                            ],
                            [
                                555.81,
                                743.07,
                                0
                            ]
                        ]
                    },
                    "cmp": {
                        "distance": 14,
                        "width": 13,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                184,
                                725.1,
                                0
                            ],
                            [
                                202.5,
                                725.8,
                                724.3
                            ],
                            [
                                253,
                                728.6,
                                727.1
                            ],
                            [
                                260.3,
                                728.81,
                                0
                            ],
                            [
                                276,
                                730.01,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                180,
                                725.1,
                                0
                            ],
                            [
                                198.5,
                                725.8,
                                724.3
                            ],
                            [
                                249,
                                728.6,
                                727.1
                            ],
                            [
                                256.3,
                                728.81,
                                0
                            ],
                            [
                                262,
                                729,
                                0
                            ]
                        ]
                    }
                },
                "deck_dist_diff": [
                    {
                        "name": "Distance",
                        "base": "15",
                        "compare": "14"
                    },
                    {
                        "name": "Width",
                        "base": "12",
                        "compare": "13"
                    },
                    {
                        "name": "Chord Station Elevation Data",
                        "base": "*",
                        "compare": "*"
                    }
                ],
                "abutment_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                },
                "pier_diff": {
                    "has_diff": true,
                    "diff": [],
                    "added": [
                        {
                            "name": "Pier#1",
                            "plan": "Multiple Run"
                        }
                    ],
                    "removed": []
                },
                "culvert_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                }
            },
            {
                "cross_section": 53750,
                "type": "Bridge",
                "deck_dist_data": {
                    "base_title": "Existing",
                    "compare_title": "Multiple Run",
                    "base": {
                        "distance": 13,
                        "width": 32,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                217,
                                726.12,
                                0
                            ],
                            [
                                230.14,
                                726.39,
                                0
                            ],
                            [
                                247.71,
                                726.4,
                                0
                            ],
                            [
                                293.72,
                                726.08,
                                0
                            ],
                            [
                                296.94,
                                726.07,
                                0
                            ],
                            [
                                300.09,
                                726.01,
                                0
                            ],
                            [
                                323.26,
                                726.17,
                                0
                            ],
                            [
                                377.39,
                                726.46,
                                0
                            ],
                            [
                                386.89,
                                726.5,
                                0
                            ],
                            [
                                395.65,
                                726.59,
                                0
                            ],
                            [
                                420.48,
                                726.78,
                                0
                            ],
                            [
                                431.69,
                                726.99,
                                0
                            ],
                            [
                                435.9,
                                727.44,
                                0
                            ],
                            [
                                443.34,
                                727.84,
                                0
                            ],
                            [
                                457.38,
                                728.45,
                                0
                            ],
                            [
                                477.54,
                                729.31,
                                0
                            ],
                            [
                                479.95,
                                729.34,
                                0
                            ],
                            [
                                498.44,
                                728.84,
                                0
                            ],
                            [
                                504.37,
                                728.71,
                                0
                            ],
                            [
                                509.31,
                                728.42,
                                0
                            ],
                            [
                                511.28,
                                728.43,
                                0
                            ],
                            [
                                541.85,
                                727.66,
                                0
                            ],
                            [
                                545.72,
                                727.61,
                                0
                            ],
                            [
                                562.64,
                                727.64,
                                0
                            ],
                            [
                                564.66,
                                727.66,
                                0
                            ],
                            [
                                567.42,
                                727.7,
                                0
                            ],
                            [
                                574.45,
                                727.88,
                                0
                            ],
                            [
                                590.88,
                                728.03,
                                0
                            ],
                            [
                                591.36,
                                728.04,
                                0
                            ],
                            [
                                602.98,
                                727.95,
                                0
                            ],
                            [
                                623.67,
                                728.19,
                                0
                            ],
                            [
                                642.16,
                                728.62,
                                0
                            ],
                            [
                                647.63,
                                728.64,
                                0
                            ],
                            [
                                649.86,
                                728.73,
                                0
                            ],
                            [
                                655,
                                729.03,
                                724.03
                            ],
                            [
                                669.7,
                                729.03,
                                724.03
                            ],
                            [
                                670.22,
                                729.03,
                                724.03
                            ],
                            [
                                755,
                                728,
                                723
                            ],
                            [
                                770.06,
                                727.12,
                                0
                            ],
                            [
                                771.35,
                                727.33,
                                0
                            ],
                            [
                                776.1,
                                728.44,
                                0
                            ],
                            [
                                800.96,
                                728.01,
                                0
                            ],
                            [
                                809.12,
                                727.78,
                                0
                            ],
                            [
                                813.4,
                                728.09,
                                0
                            ],
                            [
                                849.28,
                                728.41,
                                0
                            ],
                            [
                                856.78,
                                728.32,
                                0
                            ],
                            [
                                867.33,
                                728.43,
                                0
                            ],
                            [
                                885.68,
                                728.74,
                                0
                            ],
                            [
                                896.14,
                                728.95,
                                0
                            ],
                            [
                                911.35,
                                729.03,
                                0
                            ],
                            [
                                923.07,
                                728.89,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                0,
                                726,
                                0
                            ],
                            [
                                297,
                                726.12,
                                0
                            ],
                            [
                                310.14,
                                726.39,
                                0
                            ],
                            [
                                327.71,
                                726.4,
                                0
                            ],
                            [
                                373.72,
                                726.08,
                                0
                            ],
                            [
                                376.94,
                                726.07,
                                0
                            ],
                            [
                                380.09,
                                726.01,
                                0
                            ],
                            [
                                403.26,
                                726.17,
                                0
                            ],
                            [
                                457.39,
                                726.46,
                                0
                            ],
                            [
                                466.89,
                                726.5,
                                0
                            ],
                            [
                                475.65,
                                726.59,
                                0
                            ],
                            [
                                500.48,
                                726.78,
                                0
                            ],
                            [
                                511.69,
                                726.99,
                                0
                            ],
                            [
                                515.9,
                                727.44,
                                0
                            ],
                            [
                                523.34,
                                727.84,
                                0
                            ],
                            [
                                537.38,
                                728.45,
                                0
                            ],
                            [
                                557.54,
                                729.31,
                                0
                            ],
                            [
                                559.95,
                                729.34,
                                0
                            ],
                            [
                                578.44,
                                728.84,
                                0
                            ],
                            [
                                584.37,
                                728.71,
                                0
                            ],
                            [
                                589.31,
                                728.42,
                                0
                            ],
                            [
                                591.28,
                                728.43,
                                0
                            ],
                            [
                                621.85,
                                727.66,
                                0
                            ],
                            [
                                625.72,
                                727.61,
                                0
                            ],
                            [
                                642.64,
                                727.64,
                                0
                            ],
                            [
                                644.66,
                                727.66,
                                0
                            ],
                            [
                                647.42,
                                727.7,
                                0
                            ],
                            [
                                654.45,
                                727.88,
                                0
                            ],
                            [
                                670.88,
                                728.03,
                                0
                            ],
                            [
                                671.36,
                                728.04,
                                0
                            ],
                            [
                                682.98,
                                727.95,
                                0
                            ],
                            [
                                703.67,
                                728.19,
                                0
                            ],
                            [
                                722.16,
                                728.62,
                                0
                            ],
                            [
                                727.63,
                                728.64,
                                0
                            ],
                            [
                                729.86,
                                728.73,
                                0
                            ],
                            [
                                731.52,
                                728.69,
                                0
                            ],
                            [
                                736,
                                728.73,
                                0
                            ],
                            [
                                749.7,
                                729.03,
                                724.03
                            ],
                            [
                                750.22,
                                729.03,
                                724.03
                            ],
                            [
                                849.7,
                                728,
                                723
                            ],
                            [
                                856.1,
                                728.44,
                                0
                            ],
                            [
                                880.96,
                                728.01,
                                0
                            ],
                            [
                                889.12,
                                727.78,
                                0
                            ],
                            [
                                893.4,
                                728.09,
                                0
                            ],
                            [
                                929.28,
                                728.41,
                                0
                            ],
                            [
                                936.78,
                                728.32,
                                0
                            ],
                            [
                                947.33,
                                728.43,
                                0
                            ],
                            [
                                965.68,
                                728.74,
                                0
                            ],
                            [
                                976.14,
                                728.95,
                                0
                            ],
                            [
                                991.35,
                                729.03,
                                0
                            ],
                            [
                                1003.07,
                                728.89,
                                0
                            ]
                        ]
                    },
                    "cmp": {
                        "distance": 15,
                        "width": 26,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                657,
                                732.32,
                                0
                            ],
                            [
                                660,
                                732.32,
                                725.98
                            ],
                            [
                                677.5,
                                732.32,
                                726.08
                            ],
                            [
                                704,
                                732.08,
                                726.07
                            ],
                            [
                                734,
                                732.09,
                                725.8
                            ],
                            [
                                773.1,
                                731.89,
                                725.86
                            ],
                            [
                                784.5,
                                731.77,
                                0
                            ],
                            [
                                784.6,
                                730.12,
                                0
                            ],
                            [
                                792.6,
                                729.02,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                730,
                                730,
                                0
                            ],
                            [
                                739.4,
                                730.58,
                                725.98
                            ],
                            [
                                747,
                                730.68,
                                726.08
                            ],
                            [
                                783.4,
                                730.67,
                                726.07
                            ],
                            [
                                813.4,
                                730.4,
                                725.8
                            ],
                            [
                                843.4,
                                730.46,
                                725.86
                            ]
                        ]
                    }
                },
                "deck_dist_diff": [
                    {
                        "name": "Distance",
                        "base": "13",
                        "compare": "15"
                    },
                    {
                        "name": "Width",
                        "base": "32",
                        "compare": "26"
                    },
                    {
                        "name": "Chord Station Elevation Data",
                        "base": "*",
                        "compare": "*"
                    }
                ],
                "abutment_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                },
                "pier_diff": {
                    "has_diff": true,
                    "diff": [
                        {
                            "name": "Pier#1",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "683",
                                    "compare": "697.5"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "773",
                                    "compare": "772"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        },
                        {
                            "name": "Pier#2",
                            "diffs": [
                                {
                                    "name": "Centerline Station U.S",
                                    "base": "716",
                                    "compare": "735.28"
                                },
                                {
                                    "name": "Centerline Station D.S",
                                    "base": "806",
                                    "compare": "804.3"
                                },
                                {
                                    "name": "Width-Elevation Data",
                                    "base": "*",
                                    "compare": "*"
                                }
                            ]
                        }
                    ],
                    "added": [],
                    "removed": []
                },
                "culvert_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                }
            },
            {
                "cross_section": 53663,
                "type": "Bridge",
                "deck_dist_data": {
                    "base_title": "Existing",
                    "compare_title": "Multiple Run",
                    "base": {
                        "distance": 5,
                        "width": 58,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                150,
                                723.52,
                                0
                            ],
                            [
                                162.02,
                                723.42,
                                0
                            ],
                            [
                                165,
                                723.32,
                                0
                            ],
                            [
                                168.98,
                                723.19,
                                0
                            ],
                            [
                                173.53,
                                723.04,
                                0
                            ],
                            [
                                181.38,
                                722.96,
                                0
                            ],
                            [
                                183.38,
                                722.95,
                                0
                            ],
                            [
                                185.72,
                                723,
                                0
                            ],
                            [
                                206.69,
                                723.22,
                                0
                            ],
                            [
                                223.78,
                                723.43,
                                0
                            ],
                            [
                                240.02,
                                723.63,
                                0
                            ],
                            [
                                240.33,
                                723.4,
                                0
                            ],
                            [
                                257.14,
                                723.6,
                                0
                            ],
                            [
                                294.07,
                                724.27,
                                0
                            ],
                            [
                                309.21,
                                724.47,
                                0
                            ],
                            [
                                348.22,
                                724.97,
                                0
                            ],
                            [
                                401.62,
                                725.56,
                                0
                            ],
                            [
                                410.67,
                                725.66,
                                0
                            ],
                            [
                                465.94,
                                725.91,
                                0
                            ],
                            [
                                469.61,
                                725.89,
                                0
                            ],
                            [
                                470.6,
                                725.96,
                                0
                            ],
                            [
                                484.71,
                                726.72,
                                0
                            ],
                            [
                                484.83,
                                726.73,
                                0
                            ],
                            [
                                501.32,
                                726.89,
                                0
                            ],
                            [
                                532.48,
                                727.19,
                                0
                            ],
                            [
                                579.98,
                                727.64,
                                0
                            ],
                            [
                                628.57,
                                728.17,
                                0
                            ],
                            [
                                679.13,
                                729.19,
                                0
                            ],
                            [
                                708.74,
                                729.61,
                                0
                            ],
                            [
                                738.34,
                                730.03,
                                726.03
                            ],
                            [
                                760.9,
                                730.58,
                                726.58
                            ],
                            [
                                767.63,
                                730.74,
                                726.74
                            ],
                            [
                                796.91,
                                731.45,
                                727.45
                            ],
                            [
                                802.19,
                                731.55,
                                727.55
                            ],
                            [
                                814.9,
                                731.79,
                                727.79
                            ],
                            [
                                832.9,
                                732.14,
                                728.14
                            ],
                            [
                                863.9,
                                732.83,
                                0
                            ],
                            [
                                870.52,
                                732.99,
                                0
                            ],
                            [
                                895.03,
                                733.62,
                                0
                            ],
                            [
                                911.29,
                                734.04,
                                0
                            ],
                            [
                                919.55,
                                734.26,
                                0
                            ],
                            [
                                949.03,
                                735.44,
                                0
                            ],
                            [
                                978.51,
                                736.63,
                                0
                            ],
                            [
                                1029.88,
                                739.68,
                                0
                            ],
                            [
                                1060.05,
                                741.58,
                                0
                            ],
                            [
                                1066.55,
                                741.99,
                                0
                            ],
                            [
                                1090.21,
                                743.49,
                                0
                            ],
                            [
                                1103.2,
                                742.29,
                                0
                            ],
                            [
                                1107.18,
                                742.47,
                                0
                            ],
                            [
                                1109.76,
                                742.59,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                200,
                                723.8,
                                0
                            ],
                            [
                                412,
                                723.52,
                                0
                            ],
                            [
                                424.02,
                                723.42,
                                0
                            ],
                            [
                                427,
                                723.32,
                                0
                            ],
                            [
                                430.98,
                                723.19,
                                0
                            ],
                            [
                                435.53,
                                723.04,
                                0
                            ],
                            [
                                443.38,
                                722.96,
                                0
                            ],
                            [
                                445.38,
                                722.95,
                                0
                            ],
                            [
                                447.72,
                                723,
                                0
                            ],
                            [
                                468.69,
                                723.22,
                                0
                            ],
                            [
                                485.78,
                                723.43,
                                0
                            ],
                            [
                                502.02,
                                723.63,
                                0
                            ],
                            [
                                502.33,
                                723.4,
                                0
                            ],
                            [
                                519.14,
                                723.6,
                                0
                            ],
                            [
                                556.07,
                                724.27,
                                0
                            ],
                            [
                                571.21,
                                724.47,
                                0
                            ],
                            [
                                610.22,
                                724.97,
                                0
                            ],
                            [
                                663.62,
                                725.56,
                                0
                            ],
                            [
                                672.67,
                                725.66,
                                0
                            ],
                            [
                                727.94,
                                725.91,
                                0
                            ],
                            [
                                731.61,
                                725.89,
                                0
                            ],
                            [
                                732.6,
                                725.96,
                                0
                            ],
                            [
                                746.71,
                                726.72,
                                0
                            ],
                            [
                                746.83,
                                726.73,
                                0
                            ],
                            [
                                763.32,
                                726.89,
                                0
                            ],
                            [
                                794.48,
                                727.19,
                                0
                            ],
                            [
                                841.98,
                                727.64,
                                0
                            ],
                            [
                                890.57,
                                728.17,
                                0
                            ],
                            [
                                941.13,
                                729.19,
                                0
                            ],
                            [
                                970.74,
                                729.61,
                                0
                            ],
                            [
                                1000.34,
                                730.03,
                                726.03
                            ],
                            [
                                1022.9,
                                730.58,
                                726.58
                            ],
                            [
                                1029.63,
                                730.74,
                                726.74
                            ],
                            [
                                1058.91,
                                731.45,
                                727.45
                            ],
                            [
                                1064.19,
                                731.55,
                                727.55
                            ],
                            [
                                1076.9,
                                731.79,
                                727.79
                            ],
                            [
                                1094.9,
                                732.14,
                                728.14
                            ],
                            [
                                1125.9,
                                732.83,
                                0
                            ],
                            [
                                1132.52,
                                732.99,
                                0
                            ],
                            [
                                1157.03,
                                733.62,
                                0
                            ],
                            [
                                1173.29,
                                734.04,
                                0
                            ],
                            [
                                1181.55,
                                734.26,
                                0
                            ],
                            [
                                1211.03,
                                735.44,
                                0
                            ],
                            [
                                1240.51,
                                736.63,
                                0
                            ],
                            [
                                1291.88,
                                739.68,
                                0
                            ],
                            [
                                1322.05,
                                741.58,
                                0
                            ],
                            [
                                1328.55,
                                741.99,
                                0
                            ],
                            [
                                1352.21,
                                743.49,
                                0
                            ],
                            [
                                1365.2,
                                742.29,
                                0
                            ],
                            [
                                1369.18,
                                742.47,
                                0
                            ],
                            [
                                1371.76,
                                742.59,
                                0
                            ]
                        ]
                    },
                    "cmp": {
                        "distance": 5,
                        "width": 58,
                        "weir_coef": 2.6,
                        "us_embankment_ss": 0,
                        "ds_embankment_ss": 0,
                        "weir_crest_shape": 0,
                        "max_submergence": 0.95,
                        "min_weir_flow_el": null,
                        "station_table_us": [
                            [
                                150,
                                723.52,
                                0
                            ],
                            [
                                162.02,
                                723.42,
                                0
                            ],
                            [
                                165,
                                723.32,
                                0
                            ],
                            [
                                168.98,
                                723.19,
                                0
                            ],
                            [
                                173.53,
                                723.04,
                                0
                            ],
                            [
                                181.38,
                                722.96,
                                0
                            ],
                            [
                                183.38,
                                722.95,
                                0
                            ],
                            [
                                185.72,
                                723,
                                0
                            ],
                            [
                                206.69,
                                723.22,
                                0
                            ],
                            [
                                223.78,
                                723.43,
                                0
                            ],
                            [
                                240.02,
                                723.63,
                                0
                            ],
                            [
                                240.33,
                                723.4,
                                0
                            ],
                            [
                                257.14,
                                723.6,
                                0
                            ],
                            [
                                294.07,
                                724.27,
                                0
                            ],
                            [
                                309.21,
                                724.47,
                                0
                            ],
                            [
                                348.22,
                                724.97,
                                0
                            ],
                            [
                                520,
                                727.54,
                                0
                            ],
                            [
                                645,
                                728.87,
                                0
                            ],
                            [
                                700,
                                729.82,
                                0
                            ],
                            [
                                739.5,
                                730.69,
                                726.09
                            ],
                            [
                                829.5,
                                732.65,
                                728.05
                            ],
                            [
                                896,
                                734.3,
                                0
                            ],
                            [
                                940,
                                735.3,
                                0
                            ],
                            [
                                992.5,
                                738.08,
                                0
                            ],
                            [
                                1052.5,
                                741.86,
                                0
                            ],
                            [
                                1079,
                                743.19,
                                0
                            ],
                            [
                                1119.9,
                                746.36,
                                0
                            ]
                        ],
                        "station_table_ds": [
                            [
                                200,
                                723.8,
                                0
                            ],
                            [
                                412,
                                723.52,
                                0
                            ],
                            [
                                424.02,
                                723.42,
                                0
                            ],
                            [
                                427,
                                723.32,
                                0
                            ],
                            [
                                430.98,
                                723.19,
                                0
                            ],
                            [
                                435.53,
                                723.04,
                                0
                            ],
                            [
                                443.38,
                                722.96,
                                0
                            ],
                            [
                                445.38,
                                722.95,
                                0
                            ],
                            [
                                447.72,
                                723,
                                0
                            ],
                            [
                                468.69,
                                723.22,
                                0
                            ],
                            [
                                485.78,
                                723.43,
                                0
                            ],
                            [
                                502.02,
                                723.63,
                                0
                            ],
                            [
                                502.33,
                                723.4,
                                0
                            ],
                            [
                                519.14,
                                723.6,
                                0
                            ],
                            [
                                556.07,
                                724.27,
                                0
                            ],
                            [
                                571.21,
                                724.47,
                                0
                            ],
                            [
                                610.22,
                                724.97,
                                0
                            ],
                            [
                                663.62,
                                725.56,
                                0
                            ],
                            [
                                672.67,
                                725.66,
                                0
                            ],
                            [
                                727.94,
                                725.91,
                                0
                            ],
                            [
                                731.61,
                                725.89,
                                0
                            ],
                            [
                                732.6,
                                725.96,
                                0
                            ],
                            [
                                846,
                                727.54,
                                0
                            ],
                            [
                                916,
                                728.87,
                                0
                            ],
                            [
                                971,
                                729.82,
                                0
                            ],
                            [
                                1010,
                                730.69,
                                726.09
                            ],
                            [
                                1100,
                                732.65,
                                728.05
                            ]
                        ]
                    }
                },
                "deck_dist_diff": [
                    {
                        "name": "Chord Station Elevation Data",
                        "base": "*",
                        "compare": "*"
                    }
                ],
                "abutment_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                },
                "pier_diff": {
                    "has_diff": true,
                    "diff": [],
                    "added": [
                        {
                            "name": "Pier#1",
                            "plan": "Multiple Run"
                        }
                    ],
                    "removed": []
                },
                "culvert_diff": {
                    "has_diff": false,
                    "diff": [],
                    "added": [],
                    "removed": []
                }
            }
        ]
    }
]